import React from 'react';
import { Card } from './ui/Card';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'We generate an extra $100,000 every month just through follow-ups.',
  author: 'Luis Warkuss',
  role: 'CEO',
  initial: 'L',
  color: 'bg-blue-500'
}, {
  quote: 'We grew from $250,000 to over $450,000 in monthly revenue.',
  author: 'Henri CL',
  role: 'CEO',
  initial: 'H',
  color: 'bg-purple-500'
}, {
  quote: 'We tripled to quintupled our revenue – without massively expanding our sales team.',
  author: 'Tax Mentoring',
  role: 'Partner',
  initial: 'T',
  color: 'bg-green-500'
}];
export function ResultsSection() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <div className="text-center mb-16" data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-211">
            What My Clients Achieve
          </h2>
          <p className="text-[#94A3B8] max-w-2xl mx-auto" data-id="element-212">
            Results speak louder than words. Here are real numbers from
            companies using CRM Kraft.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-213">
          {testimonials.map((item, index) => <Card key={index} variant="hover" className="p-8 flex flex-col h-full" data-id="element-214">
              <Quote className="w-8 h-8 text-[#FF5722] mb-6 opacity-50" data-id="element-215" />
              <p className="text-lg text-white font-medium mb-8 flex-grow" data-id="element-216">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-[#1E293B]" data-id="element-217">
                <div className={`w-10 h-10 rounded-full ${item.color} flex items-center justify-center text-white font-bold`} data-id="element-218">
                  {item.initial}
                </div>
                <div data-id="element-219">
                  <div className="text-white font-bold" data-id="element-220">{item.author}</div>
                  <div className="text-xs text-[#94A3B8]" data-id="element-221">{item.role}</div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}